import {Inject, Injectable, OnDestroy} from "@angular/core";
import {Router} from "@angular/router";
import {AuthService, ConfigurationService, MODULE_VERSIONS} from "@fedeltapointofsale/data-client";
import {UserProfileSummaryData} from "../user-profile/user-profile-summary.data";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";
import {IntercomMessaging} from "./intercom-messaging";

declare let window: any;

export interface AbstractMessaging {
    init(): void

    updateUserDetails(userProfileSummary: UserProfileSummaryData): void;

    isDisplayed(): boolean

    onDestroy(): void;

    trackEvent(event: string): void;
}

/**
 * Access to the intercom Messaging Platform (chat icon in bottom right of the screen)
 *
 * See https://developers.intercom.com/installing-intercom/docs/intercom-javascript
 */
@Injectable()
export class CustomerSupportMessagingService implements OnDestroy {

    providers: AbstractMessaging[];

    constructor(private router: Router,
                private authService: AuthService,
                private configurationService: ConfigurationService,
                private responsiveService: FUIResponsiveService,
                @Inject(MODULE_VERSIONS) private moduleVersions: any[]) {
        let wboVersion: string;
        if (moduleVersions) {
            moduleVersions.forEach((v) => {
                if (v.module === "wbo") {
                    console.log("version: " + v.version);
                    wboVersion = v.version;
                }
            });
        }
        this.providers = [
            new IntercomMessaging(router, authService, configurationService, responsiveService, wboVersion),
        ];
    }

    ngOnDestroy(): void {
        this.providers.forEach(value => value.onDestroy());
    }

    /**
     * Indicates if the messaging service widget is displayed.
     */
    public isDisplayed(): boolean {
        return this.providers.find(value => value.isDisplayed()) != undefined;
    }

    /**
     * Sends an event that occurred
     * @param {string} event Name of the event
     */
    public trackEvent(event: string) {
        this.providers.forEach(value => value.trackEvent(event));
    }

    public updateUserDetails(userProfileSummary: UserProfileSummaryData): void {
        this.providers.forEach(value => value.updateUserDetails(userProfileSummary));
    }

    init(): void {
        this.providers.forEach(value => value.init());
    }
}
